// A Map to hold all our required locales formatters.
const localizedRTFMap = new Map<string, Intl.RelativeTimeFormat>();
/**
 * Returns an Intl.RelativeTimeFormat object for the specified locale.
 * In case the locale does not exist, The function will initialize its formatter and add it to the existing map.
 * @param locale The locale string for which to retrieve an Intl.RelativeTimeFormat object.
 * @returns The Intl.RelativeTimeFormat object for the specified locale.
 */
export const getRtf = (locale: string) => {
  let formatter = localizedRTFMap.get(locale);

  if (!formatter) {
    formatter = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
    localizedRTFMap.set(locale, formatter);
  }

  return formatter;
};
